module.exports = __webpack_public_path__ + "static/media/ellipse4.1757b0c3.png";